import {Box, Card, styled} from '@mui/material';
import {TagChip} from 'presentation/components';

const StyledCard = styled(Card)`
	position: relative;
	min-height: 222px;
	min-width: 384px;
	max-width: 424px;
	display: flex;
	flex-direction: column;
	border-radius: 16px;
	background-color: transparent;

	${({theme}) => theme.breakpoints.down('sm')} {
		width: 328px;
	}
`;

const StyledBox = styled(Box)`
	padding: 16px;
	flex: 1;

	background-repeat: no-repeat;
	background-size: cover;

	display: flex;
	flex-direction: column;
	justify-content: space-between;
	gap: 16px;
`;

const StyledCardHeader = styled(Box)<{$plainHeader?: boolean}>`
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	gap: 12px;
	min-height: 0;

	${({$plainHeader}) =>
		$plainHeader &&
		`
			background-repeat: no-repeat;
			background-size: cover;
			margin: -16px;
			border-radius: 0 0 16px 16px;
			padding: 12px 20px;
			margin-bottom: 18px;
			align-items: center;
	`}
`;

const StyledChip = styled(TagChip)`
	background-color: ${({theme}) => theme.colors.light.action.selected};
	align-self: end;
`;

export {StyledBox, StyledCard, StyledCardHeader, StyledChip};
